import './TableRenderer.css';

interface TableData {
  title?: string;
  columns: string[];
  rows: Array<Record<string, any>>;
  total_rows?: number;
  displayed_rows?: number;
  truncated?: boolean;
}

interface TableRendererProps {
  tableData: TableData;
}

function TableRenderer({ tableData }: TableRendererProps) {
  const { title, columns, rows, total_rows, displayed_rows, truncated } = tableData;

  if (!rows || rows.length === 0) {
    return (
      <div className="table-container">
        <div className="table-empty">No data to display</div>
      </div>
    );
  }

  return (
    <div className="table-container">
      {title && <h3 className="table-title">{title}</h3>}

      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {columns.map((column) => {
                  const cellValue = row[column];
                  const displayValue = cellValue !== null && cellValue !== undefined && cellValue !== ''
                    ? String(cellValue)
                    : '—';

                  return (
                    <td key={column} title={displayValue}>
                      {displayValue}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {(total_rows !== undefined && displayed_rows !== undefined) && (
        <div className="table-footer">
          <span className="table-info">
            Showing {displayed_rows} of {total_rows} rows
            {truncated && ' (truncated)'}
          </span>
        </div>
      )}
    </div>
  );
}

export default TableRenderer;
